import { render } from "./DBEditor.vue?vue&type=template&id=0e41401e&scoped=true"
import script from "./DBEditor.vue?vue&type=script&lang=js"
export * from "./DBEditor.vue?vue&type=script&lang=js"

import "./DBEditor.vue?vue&type=style&index=0&id=0e41401e&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/flint.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e41401e"]])

export default __exports__